import { documentToReactComponents } from '@contentful/rich-text-react-renderer';
import { BLOCKS } from '@contentful/rich-text-types';
import { FeatureCardsListItem } from './FeatureCardsListItem';

export function FeatureCardsList({ items, itemsRaw }) {
    return (
        <ul className='list-none'>
            {items?.map((detail, index) => (
                <FeatureCardsListItem key={index} detail={detail} />
            ))}
            {itemsRaw &&
                documentToReactComponents(JSON.parse(itemsRaw), {
                    renderNode: {
                        // eslint-disable-next-line react/no-unstable-nested-components
                        [BLOCKS.LIST_ITEM]: (_, children) => <FeatureCardsListItem detail={children} />,
                    },
                })}
        </ul>
    );
}
